import { createFileRoute } from '@tanstack/react-router'
import { SelectedService, validateSelectedService } from '#features/service-selection'
import { Price, ServiceType, validatePrice } from '#entities/order'

interface OrderPaymentSearch {
  tab: ServiceType
  selectedServices: SelectedService[]
  totalPrice: Price
}

export const Route = createFileRoute('/client/_post-registration-required/order-payment')({
  validateSearch: search => {
    const result: OrderPaymentSearch = {
      tab: 'ROUTINE',
      selectedServices: [],
      totalPrice: { amount: 0, currency: 'RUB' },
    }

    if (Array.isArray(search.selectedServices)) {
      result.selectedServices = search.selectedServices.map(validateSelectedService).filter(service => !!service)
    }

    result.totalPrice = validatePrice(search.totalPrice) ?? result.totalPrice

    if (['ROUTINE', 'COMPLEX', 'CUSTOM'].includes(search.tab as any)) {
      result.tab = search.tab as ServiceType
    }

    return result
  },
})
